<ion-header>
  <ion-toolbar #toolbar>
    <ion-buttons slot="start">
      <ion-button appClick (clicked)="onClose()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title><span id="page-title-span">{{ 'Vertrag Nr.' | translate }} {{ vertrag?.Vertragsnummer }}</span></ion-title>
  </ion-toolbar>
</ion-header>

<ion-content *ngIf="vertrag" class="section-content" #content>
  <div class="section">
    <div class="mb-25">
      <div class="adresse">
        <h1>{{ 'Erzeugeradresse' | translate }}</h1>
        <app-adresse [adresse]="vertrag.Erzeugeradresse" title="Erzeugeradresse" [buttonsAnzeigen]="false"></app-adresse>
      </div>
    </div>

    <div class="mb-25">
      <div class="adresse">
        <h1>{{ 'Abholadresse' | translate }}</h1>
        <app-adresse [adresse]="vertrag.Abholadresse" title="Einsatzort" [buttonsAnzeigen]="false"></app-adresse>
      </div>
    </div>
    
    <div>
        <ion-list>
            <ion-item *ngFor="let p of positionen" lines="none">
                <ion-checkbox slot="start" (ionChange)="onPositionAuswaehlen(p, $event)"></ion-checkbox>
                <span class="checkbox-text">{{ p.Menge }} {{ p.Einheit }}  {{ p.Bezeichnung }}</span>
            </ion-item>
        </ion-list>
    </div>
  </div>


  <div class="section buttons-section">
    <ion-button expand="full" color="primary" size="large" appClick (clicked)="onNeuerAuftrag()">{{ 'Neuer Auftrag' | translate }}</ion-button>
    <ion-button expand="full" color="dark" fill="clear" appClick (clicked)="onClose()">{{ 'Abbrechen' | translate }}</ion-button>
  </div>

  <div class="footer-space"></div>
</ion-content>

<!-- <ion-content #content>
  <ion-card *ngIf="vertrag" style="--background: white;">
    <ion-card-header>
      <ion-card-title>{{ 'Vertrag Nr.' | translate }} {{ vertrag.Vertragsnummer }}</ion-card-title>
    </ion-card-header>

    <ion-card-content>
      <div>
        <div class="mb-25">
          <div class="adresse">
            <h1>{{ 'Erzeugeradresse' | translate }}</h1>
            <app-adresse [adresse]="vertrag.Erzeugeradresse" title="Erzeugeradresse" [buttonsAnzeigen]="false"></app-adresse>
          </div>
        </div>

        <div class="mb-25">
          <div class="adresse">
            <h1>{{ 'Abholadresse' | translate }}</h1>
            <app-adresse [adresse]="vertrag.Abholadresse" title="Einsatzort" [buttonsAnzeigen]="false"></app-adresse>
          </div>
        </div>

        <div class="mb-25 preLine">{{ vertrag.Text }}</div>

      </div>
      <div>
        <ion-button expand="full" color="primary" size="large" appClick (clicked)="onNeuerAuftrag()">{{ 'Neuer Auftrag' | translate }}</ion-button>
        <ion-button expand="full" color="dark" fill="clear" appClick (clicked)="onClose()">{{ 'Abbrechen' | translate }}</ion-button>
      </div>
    </ion-card-content>
  </ion-card>
</ion-content> -->